import { render, staticRenderFns } from "./DialogSnowboardType.vue?vue&type=template&id=01b5da21&scoped=true"
import script from "./DialogSnowboardType.vue?vue&type=script&lang=js"
export * from "./DialogSnowboardType.vue?vue&type=script&lang=js"
import style0 from "./DialogSnowboardType.vue?vue&type=style&index=0&id=01b5da21&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b5da21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b5da21')) {
      api.createRecord('01b5da21', component.options)
    } else {
      api.reload('01b5da21', component.options)
    }
    module.hot.accept("./DialogSnowboardType.vue?vue&type=template&id=01b5da21&scoped=true", function () {
      api.rerender('01b5da21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/dialogs/dialog_snowboard _type/DialogSnowboardType.vue"
export default component.exports